import {boardSlice} from '@reducers';
import {
    findNodeFromCompressedPath,
    getFirstSetupNodeFromRoot,
    useDispatch,
    useSelector,
} from '@utils';
import {
    addMoveToCurrentNode,
    getFirstToMoveColorFromRoot,
    getRoot,
    calcMatAndMarkup,
    SGF_LETTERS,
    Ki,
    Sgf,
    TNode,
} from 'ghostban';

export const useAddCompressedPath = () => {
    const dispatch = useDispatch();
    const {root} = useSelector(state => state.board);
    const addCompressedPath = (
        compressedPath: string,
        onNodeAdded?: (
            node: TNode,
            path: string,
            index: number,
            length: number
        ) => void,
        options?: {
            customRoot?: TNode; // Use custom root instead of Redux root
            updateRedux?: boolean; // Whether to update Redux state (default: true)
        }
    ) => {
        const targetRoot = options?.customRoot || root;
        const updateRedux = options?.updateRedux ?? true;

        if (!targetRoot) return;
        const firstSetupNode = getFirstSetupNodeFromRoot(targetRoot);
        if (!firstSetupNode) return;
        const existedNode = findNodeFromCompressedPath(
            firstSetupNode,
            compressedPath
        );
        if (existedNode) return;
        let turn = getFirstToMoveColorFromRoot(targetRoot);
        const compressedPathArray = compressedPath.match(/.{1,2}/g) || [];
        let newNode = firstSetupNode;
        compressedPathArray.forEach((path, index) => {
            const i = SGF_LETTERS.indexOf(path[0].toLowerCase());
            const j = SGF_LETTERS.indexOf(path[1].toLowerCase());
            const {mat} = calcMatAndMarkup(newNode);
            const n = addMoveToCurrentNode(newNode, mat, i, j, turn);
            if (!n) {
                console.log('failed path', compressedPath, path);
                return;
            }
            if (onNodeAdded) {
                onNodeAdded(
                    n,
                    compressedPathArray.slice(0, index + 1).join(''),
                    index,
                    compressedPathArray.length
                );
            }
            turn = turn === Ki.Black ? Ki.White : Ki.Black;
            if (updateRedux) {
                const root = getRoot(n);
                dispatch(boardSlice.actions.setRoot(root));
                dispatch(boardSlice.actions.setSgf(new Sgf(root).toSgf()));
            }
            newNode = n;
        });
    };
    return [addCompressedPath];
};
